export default __webpack_public_path__ + "static/contentstack-certified-cb008a12ea493352858e37dc45d7ec44.png";